import {
	Card,
	Skeleton,
	Flex,
	Group,
} from '@mantine/core';

export const ProjectCardSkeleton: React.FC<{
	fullWidth?: boolean;
}> = ({ fullWidth }) => {
	return (
		<Card
			shadow="sm"
			pl="var(--mantine-spacing-xxs)"
			pr="var(--mantine-spacing-xxs)"
			pt="var(--mantine-spacing-xxs)"
			pb="var(--mantine-spacing-sm)"
			radius="var(--mantine-radius-lg)"
			withBorder
			miw="300px"
			maw={fullWidth ? undefined : '300px'}
			flex={fullWidth ? 1 : 0}
		>
			{/* Cover */}
			<Skeleton height={203} radius="24px" />

			<Flex
				direction="column"
				mt="var(--mantine-spacing-sm)"
				pl="var(--mantine-spacing-xxs)"
				pr="var(--mantine-spacing-xxs)"
			>
				{/* Row 1: Country, location, price label */}
				<Flex gap="var(--mantine-spacing-xs)" mih="20px">
					<Group gap="5px">
						<Skeleton
							height={18}
							width={18}
							radius="xl"
						/>{' '}
						{/* Flag */}
						<Skeleton height={12} width={60} />{' '}
						{/* Country */}
					</Group>
					<Group gap="5px">
						<Skeleton height={12} width={70} />{' '}
						{/* Place */}
					</Group>
					<Flex flex={1} justify="end">
						<Skeleton height={12} width={100} />{' '}
						{/* Sell price label */}
					</Flex>
				</Flex>

				{/* Row 2: Price */}
				<Flex gap="var(--mantine-spacing-xs)" mt="xs">
					<Flex flex={1} justify="end">
						<Skeleton height={16} width={80} />{' '}
						{/* Price value */}
					</Flex>
				</Flex>

				{/* Row 3: Project label */}
				<Flex mt="var(--mantine-spacing-xs)">
					<Skeleton height={12} width="40%" />
				</Flex>

				{/* Row 4: Project name */}
				<Flex mt="xs">
					<Skeleton height={16} width="80%" />
				</Flex>

				{/* Row 5: Project type */}
				<Flex
					gap="var(--mantine-spacing-xs)"
					mt="var(--mantine-spacing-sm)"
				>
					<Skeleton height={12} width="40%" />
					<Skeleton height={12} width="60%" />
				</Flex>

				{/* Row 6: Stock disponible */}
				<Flex
					gap="var(--mantine-spacing-xs)"
					mt="var(--mantine-spacing-xs)"
				>
					<Skeleton height={12} width="40%" />
					<Skeleton height={12} width="60%" />
				</Flex>

				{/* Row 7: Button */}
				<Skeleton
					height={36}
					mt="var(--mantine-spacing-md)"
					radius="md"
				/>
			</Flex>
		</Card>
	);
};
